import { makeAutoObservable } from "mobx";
import { createMutations } from "./mutations";
import { initialState, templateInitialState } from "./state";

/**
 * @typedef {typeof initialState & typeof templateInitialState & {
 *   setCurrentPage: (value: any) => void,
 *   setPageSize: (value: any) => void,
 *   setFilterSearchText: (value: any) => void,
 *   setFilterModel: (value: any) => void,
 *   setIsLoading: (value: any) => void,
 *   setRowData: (value: any) => void,
 *   setShowFilterModal: (value: any) => void,
 *   setLandingPages: (items: any[]) => void,
 *   setTotalRow: (value: any) => void,
 *   setDefaultState: () => void,
 *   setTemplateDefaultState: () => void,
 *   setLandingPage: (value: any) => void,
 *   setTemplateLandingPages: (value: any) => void,
 *   setTemplateLandingPage: (value: any) => void,
 *   setTemplateTotalRow: (value: any) => void,
 *   setTemplateIsLoading: (value: any) => void,
 *   setBeeEditor: (value: any) => void,
 *   setBeePluginLoading: (value: any) => void,
 *   setTemplateBeePluginLoading: (value: any) => void,
 *   setTemplateActiveLandingPageTab: (value: any) => void,
 *   setActiveLandingPageTab: (value: any) => void,
 *   setLandingPageDraftName: (value: any) => void,
 *   setTemplateLandingPageDraftName: (value: any) => void,
 *   setHasChanges: (value: any) => void,
 *   setTemplateHasChanges: (value: any) => void,
 *   setLandingPageDns: (value: any) => void,
 *   setLandingPageUrl: (value: any) => void,
 *   setLandingPageDescription: (value: any) => void,
 *   setLandingPageCategories: (value: any) => void,
 *   setTemplateLandingPageUrl: (value: any) => void,
 *   setTemplateLandingPageDescription: (value: any) => void,
 *   setTemplateLandingPageCategories: (value: any) => void,
 *   setIsShowWizardModal: (value: any) => void,
 *   setTemplateDefaultLandingPageTab: (value: any) => void,
 *   setHtml: (value: any) => void,
 *   setSubdomain: (value: any) => void,
 *   setCategory: (value: any) => void,
 *   setIsFromTemplate: (value: any) => void,
 *   setTemplateHtml: (value: any) => void,
 *   setTemplateSubdomain: (value: any) => void,
 *   setTemplateCategory: (value: any) => void,
 *   setSubdomains: (value: any) => void,
 *   setIsLoadingSubdomains: (value: any) => void,
 *   setCompanySubdomainId: (value: any) => void,
 *   setGoogleAnalytics: (value: any) => void,
 *   setTemplateCurrentPage: (value: any) => void,
 *   setTemplatePageSize: (value: any) => void,
 *   setTemplateFilterSearchText: (value: any) => void,
 *   setTemplateFilterModel: (value: any) => void,
 *   setTemplateIsLoading: (value: any) => void,
 *   setTemplateTotalRow: (value: any) => void,
 * }} LandingPageStore
 */

const landingPageStore = () => {
  const store = {
    ...initialState,
    ...templateInitialState
  };

  makeAutoObservable(store);

  Object.assign(store, createMutations(store));

  /** @type {LandingPageStore} */
  return store;
};

/** @type {LandingPageStore} */
export default landingPageStore();
